import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'rx-icon-legacy',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})

/**
* @deprecated This library has been deprecated in favor of using Icon library that supports SVG please use IconSvgComponent instead
*/
export class IconLegacyComponent {
  /** Icon name */
  @HostBinding('class') @Input() icon;
}
